import React from 'react';

const Card = ({ children }) => {
  return <div className="bg-white rounded-lg shadow-md overflow-hidden">{children}</div>;
};

const CardHeader = ({ children }) => {
  return <div className="p-6 pb-3">{children}</div>;
};

const CardTitle = ({ children }) => {
  return <h3 className="text-lg font-medium">{children}</h3>;
};

const CardDescription = ({ children }) => {
  return <p className="text-sm text-gray-500 mt-1">{children}</p>;
};

const CardContent = ({ children }) => {
  return <div className="p-6 pt-3">{children}</div>;
};

const CardFooter = ({ children }) => {
  return <div className="p-6 pt-0 flex items-center">{children}</div>;
};

export { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter };
